import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { style } from '../utils/style.utils';

@Directive({
    selector: 'input[sag-ui-filedrop]'
})
export class FileDropDirective implements OnInit {
    private accept = '*/*';

    constructor(private readonly elementRef: ElementRef<HTMLInputElement>, private renderer: Renderer2) {}

    public ngOnInit(): void {
        this.initRenderer();
    }

    private initRenderer(): void {
        const containerStyles = ['absolute', 'top-0', 'left-0', 'w-full', 'h-full', 'cursor-pointer'];

        const container = this.renderer.createElement('label');
        const input = this.elementRef.nativeElement;

        this.accept = input.accept;

        style(this.elementRef, 'hidden peer');

        this.renderer.setAttribute(container, 'class', containerStyles.join(' '));
        this.renderer.setAttribute(container, 'for', input.id);

        this.renderer.listen(container, 'dragover', event => {
            event.preventDefault();
            event.stopPropagation();
        });

        this.renderer.listen(container, 'dragenter', event => {
            event.preventDefault();
            event.stopPropagation();
        });

        this.renderer.listen(container, 'drop', event => {
            event.preventDefault();
            event.stopPropagation();

            const files: File[] = Array.from(event.dataTransfer.files);
            const acceptedFiles = files.filter(file => this.isFileAccepted(file));

            if (acceptedFiles.length > 0) {
                const dataTransfer = new DataTransfer();
                acceptedFiles.forEach(file => dataTransfer.items.add(file));
                input.files = dataTransfer.files;

                const changeEvent = new Event('change', { bubbles: true });
                input.dispatchEvent(changeEvent);
            }
        });

        this.renderer.insertBefore(
            this.elementRef.nativeElement.parentElement,
            container,
            this.elementRef.nativeElement
        );
    }

    private isFileAccepted(file: File): boolean {
        if (this.accept === '*' || this.accept === '*/*' || this.accept === '' || !this.accept) {
            return true; // Accept all files
        }

        const acceptedTypes = this.accept.split(',').map(type => type.trim());
        return acceptedTypes.some(type => {
            if (type.startsWith('.')) {
                // Match by file extension
                return file.name.toLowerCase().endsWith(type.toLowerCase());
            } else {
                // Match by MIME type
                const [typeMain, typeSubtype] = type.split('/');
                const [fileMain, fileSubtype] = file.type.split('/');
                return (
                    (typeMain === '*' || typeMain === fileMain) && (typeSubtype === '*' || typeSubtype === fileSubtype)
                );
            }
        });
    }
}
